export default "__VITE_ASSET__CMCmJAYY__"